// extracted by mini-css-extract-plugin
export var li = "_vz-2";
export var ol = "_vz-1";
export var ul = "_vz-0";